import React from "react";
import { IoLogInSharp, IoLocationSharp } from "react-icons/io5";
import { FaArrowRight, FaCartArrowDown } from "react-icons/fa6";
import { FaPhoneAlt, FaEnvelope, FaGlobe } from "react-icons/fa";
import TestimonialSlider from "../Testimonials";

const OurServices = () => {
  return (
    <section className="py-16 bg-gray-50 lg:mt-5 mt-24">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl  text-gray-900">
          Our <span className="text-primary-dark font-bold">Process</span>
        </h2>
        <p className="text-gray-600 mt-2 w-96 lg:w-1/2 mx-auto">
          We have created a seamless process that you can follow to receive your
          orders and the process is explained below.
        </p>
      </div>

      <div className="mt-12 flex flex-col md:flex-row items-center justify-center gap-8 lg:gap-36">
        {/* Secure Packaging */}
        <div className=" relative w-[273px] h-[326px] bg-teal-100 rounded-[10px] flex flex-col justify-center items-center p-6">
          <div className="absolute -top-4 right-0 text-7xl text-white font-black ">
            1
          </div>
          <div className="flex flex-col items-start">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-[#64D0C5] rounded-md">
                <IoLogInSharp className="text-white text-3xl" />
              </div>
              <h3 className="text-lg font-semibold text-[#4267B2]">Sign Up</h3>
            </div>
            <p className="text-gray-900 mt-6">
              Create an account to access our seamless medical courier services.
            </p>
          </div>
        </div>

        {/* Fast Delivery */}
        <div className=" relative w-[273px] h-[326px] bg-blue-100 rounded-[10px] flex flex-col justify-center items-center p-6">
          <div className="absolute -top-4 right-0 text-7xl text-white font-black ">
            2
          </div>
          <div className="flex flex-col items-start">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-[#4267B2] rounded-md">
                <FaCartArrowDown className="text-white text-3xl" />
              </div>
              <a href="/order-delivery" className="text-lg font-semibold text-[#4267B2]">
                Make a Request
              </a>
            </div>
            <p className="text-gray-900 mt-6">
              Submit a delivery request with the necessary details
            </p>
          </div>
        </div>

        {/* Real-Time Tracking */}
        <div className=" relative w-[273px] h-[326px] bg-red-100 rounded-[10px] flex flex-col justify-center items-center p-6">
          <div className="absolute -top-4 right-0 text-7xl text-white font-black ">
            3
          </div>
          <div className="flex flex-col items-start">
            <div className="flex items-center gap-3">
              <div className="p-3 bg-[#F94D53] rounded-md">
                <IoLocationSharp className="text-white text-3xl shadow-2xl shadow-white" />
              </div>
              <h3 className="text-lg font-semibold text-[#4267B2]">
                Track Your Delivery
              </h3>
            </div>
            <p className="text-gray-900 mt-6">
              Get real-time updates until your package reaches its destination.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
const ImpactLogisticsSection = () => {
  return (
    <div
      id="services"
      className="bg-[#0D1B40] text-white relative min-h-screen pt-8 md:pt-16 px-4 xl:px-0"
    >
  

      <div className="max-w-7xl mx-auto mt-8 md:mt-24">
        <h2 className="text-2xl md:text-4xl font-semibold text-center px-4 mb-8 md:mb-12">
          What you can do with{" "}
          <span className="font-bold">Impact Logistics</span>
        </h2>

        <div className="max-w-6xl mx-auto relative">
          <div className="absolute inset-0 mx-auto w-full md:w-2/4 h-full bg-[url(]'/img/Website/Group.png')] bg-contain bg-no-repeat bg-center opacity-40 z-0"></div>

          <div className="flex lg:flex-row flex-col items-center justify-center z-10">
            {/* Left column */}
            {/* <div className="space-y-6 px-4 md:px-6 xl:px-0">
              <div className="space-y-4">
                <img
                  src="/img/Website/boxIcon.png"
                  alt="Box"
                  className="w-12 h-12 block sm:hidden md:block"
                />
                <div>
                  <h3 className="text-lg font-semibold mb-2">
                    Medical Specimen & Pharmaceutical Transport
                  </h3>
                  <p className="text-gray-300">
                    Reliable transport for healthcare providers.
                  </p>
                </div>
              </div>
            </div> */}

            {/* Middle column */}
            <div className="space-y-6 items-center px-4 md:px-6 xl:px-0">
              <div className="space-y-4 flex flex-col lg:flex-row items-center gap-4">  
                <img
                  src="/img/Website/boxIcon.png"
                  alt="Box"
                  className="w-12 h-12"
                />
                <div>
                  <h3 className="text-lg font-semibold mb-2">
                    Hospital & Clinic Logistics
                  </h3>
                  <p className="text-gray-300">
                    Reliable transport for healthcare providers.
                  </p>
                </div>
              </div>

              <div className="pt-6 flex flex-col lg:items-start items-center md:pt-8">
                <h3 className="text-xl font-semibold mb-4">
                  Need a medical courier?
                </h3>
                <a
                  href="/order-delivery"
                  className="bg-blue-500 hover:bg-[#049DDB] text-white px-6 py-3 rounded-md inline-block transition-colors duration-300"
                >
                  Make a Request
                </a>
              </div>
            </div>

            {/* Right column - Image */}
            <div className="md:col-span-1 xl:col-span-1">
              <div className="relative h-full">
                <img
                  src="/img/Website/Group-108.png"
                  alt="Courier"
                  className="rounded-md border-4 border-[#0D1B40] border-solid w-full h-auto object-cover md:max-h-[400px] xl:max-h-none"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AboutUsSection = () => {
  return (
    <section id="about" className="bg-gray-100 py-12 md:py-24 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        {/* About Us */}
        <h2 className="text-2xl md:text-3xl text-center font-medium text-gray-800 py-6 md:py-10 mb-8 md:mb-11">
          About Us
        </h2>
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <img
            src="/img/Website/Rectangle.png"
            alt="Medical Logistics"
            className="rounded-lg shadow-lg"
          />
          <div>
            <p className="text-gray-600 mb-4">
              At Impact Logistics, we understand that every second counts in
              medical logistics. Whether it’s urgent lab samples, life-saving
              medications, or essential medical equipment, we ensure fast,
              secure, and reliable deliveries across multiple regions.
            </p>
            <p className="text-gray-600">
              With a dedicated team of trained couriers, we specialize in the
              safe handling and timely transport of medical items, meeting the
              strictest industry standards. Our mission is to support healthcare
              providers with seamless delivery solutions that help save lives.
            </p>
          </div>
        </div>

        {/* Testimonials */}
        <div className="mt-16 border-t border-[#049DDB] border-solid pt-8">
          <TestimonialSlider />
        </div>

        {/* Contact Section */}
        <div
          id="contact"
          className="mt-16 border-t border-[#049DDB] border-solid pt-8 grid md:grid-cols-2 gap-8 items-center"
        >
          <div>
            <h3 className="text-2xl font-bold text-gray-800">
              Are you interested in{" "}
              <span className="text-[#049DDB]">Medical Package Delivery?</span>
            </h3>
            <p className="text-[#049DDB] mt-2">
              You can contact us for more information
            </p>
            <div className="mt-4 space-y-2">
              <p className="flex items-center text-gray-700">
                <FaPhoneAlt className="text-[#049DDB] mr-2" /> 732 506 8608
              </p>
              <p className="flex items-center text-gray-700">
                <FaEnvelope className="text-[#049DDB] mr-2" />{" "}
                info@impactlogisticsservices.com
              </p>
              <p className="flex items-center text-gray-700">
                <FaGlobe className="text-primary-light mr-2" />{" "}
                impactlogisticsservices.com
              </p>
            </div>
            <p className="mt-4 font-bold text-gray-800">
              Mon - Fri :{" "}
              <span className="text-primary-light">08:00 am – 06:00 pm</span>
            </p>
            <p className="text-gray-700">Sat - Sun: Closed</p>
          </div>
          <iframe
            className="w-full h-64 rounded-lg "
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2978.0216375217415!2d-74.901596!3d39.9716246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c14a73bc04f453%3A0xc849595763ce7dec!2s1025%20Briggs%20Rd%2C%20Mt%20Laurel%20Township%2C%20NJ%2008054%2C%20USA!5e1!3m2!1sen!2sgh!4v1746593622887!5m2!1sen!2sgh"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
};
const Body = () => {
  return (
    <div>
      <OurServices />
      <ImpactLogisticsSection />
      <AboutUsSection />
      <div className="bg-[#EBEBEB]">
        <div className="max-w-7xl mx-auto px-4 py-6 flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
          {/* Image Section */}
          <div className="w-full md:w-auto flex justify-center">
            <img
              src="/img/Website/9.png"
              alt="Shipping Illustration"
              className="w-[80%] md:w-auto lg:w-full"
            />
          </div>

          {/* Text Content */}
          <div className="w-full md:w-[60%] flex flex-col items-center md:items-end gap-4 md:gap-6 text-center md:text-right">
            {/* <p className="text-sm md:text-base leading-relaxed">
              People who use <strong>IMPACT LOGISTICS</strong> for their
              shipping save on average
              <span className="text-[#049DDB] font-semibold"> 32%</span> on
              their shipments compared to other shipping companies.
            </p> */}
            <a
              href="/order-delivery"
              className="bg-[#049DDB] rounded-full py-2 px-5 text-white flex items-center gap-2 shadow-md hover:bg-[#037bb5] transition"
            >
              Request a Delivery now
              <span>
                <FaArrowRight />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Body;
